import { makeVar, useReactiveVar } from "@apollo/client"
import { HeartbeatFragment } from "@pathwright/graphql-client/src/generated"

// Stores the last heartbeat time and the IDs of the active subscriptions.
export type Heartbeat = {
  time: Date
} & Partial<Omit<HeartbeatFragment, "success">>

export function getHeartbeat(
  heartbeat?: HeartbeatFragment | null | undefined
): Heartbeat {
  return heartbeat
    ? {
        time: new Date(),
        active_subscription_ids: heartbeat.active_subscription_ids,
        membership: heartbeat.membership,
        deploy: heartbeat.deploy ?? null
      }
    : {
        time: new Date(),
        deploy: null
      }
}

export const lastHeartbeatVar = makeVar<Heartbeat>(getHeartbeat())
export const useLastHeartbeatVar = () => useReactiveVar(lastHeartbeatVar)
